import React, { useCallback, useEffect, useState } from 'react'
import { EnhancedInputField } from './EnhancedInputField'
import axios from 'axios';
import { API } from '../../shared/api/Api';
import { showToast } from '../../utils/utils';
import { useSelector } from 'react-redux';
import { selectUserInformations } from '../../features/authSlice';

const StudentsCourseItems = ({ field, formData, type, handleChange, disabled = false }) => {
    const [students, setStudents] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);

    const user = useSelector(selectUserInformations);

    // Initial fetch
    const fetchStudentsCourse = useCallback(async (page = 1) => {
        try {
            const { data } = await axios.get(`${API.Students.app_students_all}`, {
                params: {
                    page,
                    limit: 20,
                },
                headers: { Authorization: `Bearer ${user.token}` },
            });

            if (data.status === 200 && data.errorCode === 0) {
                if (page === 1) {
                    setStudents(data.data.items);
                } else {
                    setStudents((prev) => [...prev, ...data.data.items]);
                }
                setCurrentPage(page);
                setHasMore(data.data.current_page < data.data.last_page);
                return true;
            } else {
                showToast("Error", "Failed to fetch students", "error");
                return false;
            }
        } catch (error) {
            showToast(
                "Error",
                error.response?.data?.message || "An error occurred",
                "error"
            );
            return false;
        }
    }, [user.token]);

    // Load more students with pagination
    const loadMoreStudents = useCallback(async () => {
        if (loading || !hasMore) return;
        setLoading(true);
        await fetchStudentsCourse(currentPage + 1);
        setLoading(false);
    }, [currentPage, hasMore, loading, fetchStudentsCourse]);

    // Initial load
    useEffect(() => {
        const fetchData = async () => {
            setInitialLoading(true);
            await fetchStudentsCourse(1);
            setInitialLoading(false);
        };
        fetchData();
    }, [fetchStudentsCourse]);

    const options = students.map((item) => ({
        id: item.id,
        name: `${item.first_name} ${item.last_name}`,
        title: `${item.first_name} ${item.last_name}`,
    }));

    if (initialLoading) {
        return (
            <div className="flex items-center justify-center py-4">
                <div className="w-5 h-5 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
            </div>
        );
    }

    return (
        <EnhancedInputField
            key={field.name}
            label={field.label}
            name={field.name}
            type={field.type}
            placeholder={field.placeholder}
            value={formData[field.name]}
            handleChange={handleChange}
            options={options}
            disabled={disabled}
            onLoadMore={hasMore ? loadMoreStudents : null}
            hasMore={hasMore}
            loading={loading}
        />
    )
}

export default StudentsCourseItems
